/* eslint-disable */
export const FORMAT_NUMBER = '^[0-9]+$';
/* eslint-disable */
export const FORMAT_NUMBER_NO_ZERO = '^[1-9]+$';
/* eslint-disable */
export const GREATER_THAN_ZERO = '^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$';
/* eslint-disable */
export const FORMAT_2DECIMALS = '^[0-9]+(\.[0-9]{2})?$';
/* eslint-disable */
export const FORMAT_3DECIMALS = '^[0-9]+(\.[0-9]{3})?$';
/* eslint-disable */
export const FORMAT_5DECIMALS = '^[0-9]+(\.[0-9]{5})?$';
/* eslint-disable */
export const FORMAT_DATE = '^(3[01]|[12][0-9]|0[1-9])[-/](1[0-2]|0[1-9])[-/][0-9]{4}$';
/* eslint-disable */
export const FORMAT_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const FORMAT_DAM = '^[0-9]{3}-[0-9]{4}-[0-9]{2}-[0-9]{1,6}$';

